import { defineMessages } from 'react-intl';

export default defineMessages({
    requiringPostIssueReview: {
        id: 'custom.quoteandbind.pa.views.pa-policy-info.Items requiring Post Issue Review',
        defaultMessage: 'Items requiring Post Issue Review',
    },
});
